import React, { useState, useEffect } from 'react';
import { Box, BoxExtendedProps, BoxProps } from 'grommet';
import styled from 'styled-components';
import { FormRefresh } from 'grommet-icons';
import SHDText from '@ui/Text/SHDText';
import useIScore from '@hooks/useIScore';
import { formatSyncTime } from '@helpers/dateUtils';
import useEventsGameStart from '@hooks/useEventsGameStart';
import { GameStartEvent } from './schedule.d';

interface iScoreSyncButtonProps {
  teamId: string;
}

const IScoreSyncButton: React.FC<iScoreSyncButtonProps> = ({ teamId }) => {
  const { trackGameStartEvent } = useEventsGameStart(teamId);
  const { syncIScoreSchedule, isSyncing, lastModified, error } =
    useIScore(teamId);
  const [buttonLabel, setButtonLabel] = useState<string>(
    `Last Synced at ${`12:00 PM`}`
  );

  useEffect(() => {
    syncIScoreSchedule();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSyncing) {
      setButtonLabel('Syncing...');
    } else if (!isSyncing) {
      setButtonLabel(`Last Synced at ${formatSyncTime(lastModified)}`);
    }
    if (error) {
      setButtonLabel('iScore sync failed');
    }
  }, [isSyncing, error, lastModified]);

  const handleSyncButton = () => {
    trackGameStartEvent(GameStartEvent.ISCORE_SYNC_CLICKED);
    syncIScoreSchedule();
  };

  return (
    <Box
      data-testid="iscore-sync-button"
      direction="row"
      align="center"
      justify="center"
      alignContent="baseline"
      onClick={handleSyncButton}
    >
      <Box>
        <SHDText color="black-alpha-40">{buttonLabel}</SHDText>
      </Box>
      <SyncIcon start={isSyncing ? 'infinite' : 'forwards'}>
        <FormRefresh color="black-alpha-40" />
      </SyncIcon>
    </Box>
  );
};

interface SyncIconProps extends BoxExtendedProps {
  start: string;
}

const SyncIcon: React.FC<SyncIconProps & BoxProps> = styled(Box)<SyncIconProps>`
  animation: rotate 1s linear ${(props) => props.start};

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;

export default IScoreSyncButton;
